// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__2wGAJ","tab":"Tabs_tab__2Damw","tabActive":"Tabs_tabActive__3fKkN"};